export default __webpack_public_path__ + "static/media/Plus_White.3e1da926.svg";